import { useMemo } from "react";
import { Navbar, Nav, Container, NavDropdown } from "react-bootstrap";
import { NavLink, Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../Redux/userSlice";
import "./navbar.css";
import Swal from "sweetalert2";
import i18n from "../i18n";
import ReactCountryFlag from "react-country-flag";

function Navbarr({ setLanguage, t }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userState = useSelector((state) => state.user);
  const user = userState?.user;
  const profileLink = useMemo(() => {
    if (!user) return "/Login";
    if (user.category === "User") return "/profile";
    if (user.category === "Admin") return "/dash-admin";
    if (user.category === "SAdmin") return "/dash-s-admin";
    return "/enseignant";
  }, [user]);

  const handleLogout = () => {
    Swal.fire({
      title: t("navbar.logoutTitle"),
      html: t("navbar.logoutMessage"),
      timer: 2000,
      timerProgressBar: true,
      willClose: () => {
        dispatch(logout());
        navigate("/");
      },
    });
  };

  // test
  const { name, last_name } = user || {};
  if (!i18n.isInitialized) return null;
  return (
    <Navbar
      expand="lg"
      bg="white"
      style={{
        minHeight: "96px",
        zIndex: 1050,
        padding: 0,
        position: "sticky",
        top: 0,
      }}
    >
      <Container fluid className="ps-3 ps-lg-5 pe-3 pe-lg-0">
        {/* BRAND */}
        <Navbar.Brand
          as={Link}
          to="/"
          className="d-flex align-items-center gap-3"
        >
          <img
            src="/Logo SL rouge1.png"
            alt="Solutions Langues"
            width="46"
            height="46"
          />
          <div className="fw-bold text-danger text-uppercase lh-sm small">
            <div>Solutions</div>
            <div>Langues</div>
          </div>
        </Navbar.Brand>

        {/* TOGGLE */}
        <Navbar.Toggle
          aria-controls="main-navbar"
          className="border-0 shadow-none"
        />

        <Navbar.Collapse id="main-navbar" style={{marginRight:"25px"}}>
          <Nav className="mx-auto text-uppercase small fw-semibold gap-lg-1 text-center text-lg-start py-3 py-lg-0 align-items-lg-center">
            <NavLink to="/" className="nav-link">
              {t("navbar.home")}
            </NavLink>
            <NavLink to="/about" className="nav-link">
              {t("navbar.whoWeAre")}
            </NavLink>

            <NavDropdown
              title={t("navbar.ourTraining")}
              className="hover-dropdown"
            >
              <NavDropdown.Item as={Link} to="/French-Courses">
                {t("navbar.frenchCourses")}
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/Business-French">
                {t("navbar.businessFrench")}
              </NavDropdown.Item>
            </NavDropdown>

            <NavDropdown
              title={t("navbar.examsPreparation")}
              className="hover-dropdown "
            >
              <NavDropdown.Item as={Link} to="/TEF">
                {t("navbar.tef")}
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/TCF">
                {t("navbar.tcf")}
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/DELF-DALF">
                {t("navbar.delfDalf")}
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/PrepMyFuture">
                {t("navbar.prepMyFuture")}
              </NavDropdown.Item>
            </NavDropdown>

            <NavLink to="/TEF-registration" className="nav-link">
              {t("Inscription TEF")}
            </NavLink>

            <NavLink to="/DFP-registration" className="nav-link">
              {t("Inscription DFP")}
            </NavLink>
            <NavDropdown
              title={
                <div
                  style={{ display: "flex", gap: "8px", alignItems: "center" }}
                >
                  <img
                    src="/Flag-Quebec.webp"
                    alt="Français (Québec)"
                    width="22"
                    height="16"
                    style={{
                      width: 22,
                      height: 16,
                      objectFit: "cover",
                      borderRadius: "2px",
                    }}
                  />

                  <ReactCountryFlag
                    countryCode="ES"
                    svg
                    style={{ width: 22, height: 16 }}
                    title="Español"
                  />

                  <ReactCountryFlag
                    countryCode="GB"
                    svg
                    style={{ width: 22, height: 16 }}
                    title="English (England)"
                  />
                </div>
              }
              align="end"
              className="hover-dropdown "
            >
              <NavDropdown.Item onClick={() => setLanguage("EN")}>
                English
              </NavDropdown.Item>
              <NavDropdown.Item onClick={() => setLanguage("FR")}>
                Français
              </NavDropdown.Item>
              <NavDropdown.Item onClick={() => setLanguage("ES")}>
                Español
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>
          <div
            className="d-flex align-items-center justify-content-center justify-content-lg-end gap-2 mt-3 mt-lg-0 ms-lg-2 flex-wrap pb-3 pb-lg-0"
            style={{ minHeight: "60px" }}
          >
            {user ? (
              <NavDropdown
                title={
                  <div className="d-flex align-items-center gap-2">
                    <span className="fw-semibold text-dark">{`${name} ${last_name}`}</span>
                  </div>
                }
                id="user-dropdown"
                align="end"
                className="hover-dropdown"
              >
                <NavDropdown.Item as={Link} to={profileLink}>
                  {t("navbar.profile")}
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item
                  onClick={handleLogout}
                  className="text-danger"
                >
                  {t("navbar.logout")}
                </NavDropdown.Item>
              </NavDropdown>
            ) : (
              <Link
                to="/login"
                className="btn btn-danger btn-sm text-white text-decoration-none fw-semibold rounded-pill px-3 py-2 shadow-sm"
              >
                {t("navbar.loginSignup")}
              </Link>
            )}

            <Link
              to="/contact"
              className="btn border-danger text-danger btn-sm text-decoration-none fw-semibold rounded-pill px-3 py-2"
              onMouseOver={(e) => {
                e.target.style.backgroundColor = "#dc3545";
                e.target.style.color = "#fff";
              }}
              onMouseOut={(e) => {
                e.target.style.backgroundColor = "transparent";
                e.target.style.color = "#dc3545";
              }}
            >
              {t("navbar.contactUs")}
            </Link>
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Navbarr;
